import React, { useEffect, useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import { Link, useLocation, useHistory } from 'react-router-dom';
import DevAuthAPI from '../../../api/DevAuth';
import Close from '../../../Assets/close.svg';
import Exclamation from '../../../Assets/exclamationcircle.svg';
import Input from "../../../components/Input"
import { CustomToast } from '../../../util/custom-toast/CustomToast';
import { hideLoader, showLoader } from '../../../util/loader/CustomLoader';
import ForwardArrow from "../../../Assets/forward-arrow.svg";
import GreenCheck from "../../../Assets/green-check.svg";
const MailExpiry = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const message = query.get('message');
    console.log("Message", message);
    const [attempt, setAttempt] = useState(1);
    const [email, setEmail] = useState({ value: "", warning: { msg: "", class: "" } });
    const [emailAlreadyVerified, setEmailAlreadyVerified] = useState(false);
    const [LinkAlreadyUsed, setLinkAlreadyUsed] = useState(false);
    useEffect(() => {
        let temp1 = window.location.hash.split("=");
        setEmail({ value: temp1[1], warning: { class: "text-gray" } });
        switch (message) {
            case "This account is already verified.":
                setEmailAlreadyVerified(true);
                break;
            case "This URL can be used only once":
                setLinkAlreadyUsed(true);
                break;
            default:
                setEmailAlreadyVerified(false)
                setLinkAlreadyUsed(false)
        }
    }, [message])
    
    function resendLink() {
        showLoader();
        setAttempt(attempt + 1);
        console.log("Attempt is: ", attempt);
        var api = new DevAuthAPI();
        if (attempt < 3) {
            api.resendVerificationEmail({ email: email.value })
                .then((response) => {
                    hideLoader();
                    CustomToast(`Please check your email to verify signup : Attempt ${attempt + 1}`)
                })
                .catch((error) => {
                    hideLoader();
                    CustomToast(error.response.data.message);
                    if(error?.response?.data?.error_code==="E09005"){
                    setEmailAlreadyVerified(true);
                    }
                });
        }
        else {
            CustomToast(
                `Resend Email Verification maximum
                attempts reached, please try after 5
                mins.`);
            setTimeout(() => setAttempt(1), 300000);
            hideLoader();
        }
    }
    return (
        <Modal
            show={true}
            centered
            contentClassName="mail-modal p-2"
        >
            <Link to="/" style={{ marginLeft: '95%' }}>
                <img
                    src={Close}
                    height="14"
                    width="14"
                    alt="cross"
                />
            </Link>
            <Modal.Body>
                <Container className="text-center col-xs-1 mail-expiry">

                    {( emailAlreadyVerified || LinkAlreadyUsed ) ? <Container className="text-center col-xs-1">
                        <img
                            alt="mail-verified"
                            src={GreenCheck}
                            height="25"
                        />
                        <h4 className="mt-2">Thank you!</h4>
                        <p className="mt-4">
                            You have successfully registered your
                            account,
                        </p>
                        <p>please click below to sign in </p>

                        <Link to="/login" replace="true">
                            <p className="link">
                                Sign In{' '}
                                <img
                                    alt="login"
                                    src={ForwardArrow}
                                    height="12"
                                    width="13"
                                    style={{ marginTop: -2 }}
                                />
                            </p>
                        </Link>
                    </Container>
                        : <div><img
                            alt="mail-expiry"
                            src={Exclamation}
                            height="25"
                        /><h4 className="mt-2">Your activation link has expired</h4>
                        <p>To get a new activation link click on the "Resend Activation<br/>Link" button</p>
                        </div>
                    }
                    {(!emailAlreadyVerified && !LinkAlreadyUsed) &&
                        (
                            <>
                                <div>
                                    <Input
                                        required="true"
                                        label="Email ID"
                                        type="email"
                                        name="email"
                                        maxLen="256"
                                        warning={email.warning}
                                        value={email.value}
                                        autoComplete="nope"
                                        disabled
                                        style={{ marginBottom: "-5px" }}
                                    />
                                    <a onClick={() => resendLink()} className={`link`}>
                                        Resend Activation Link{' '}
                                    </a>
                                </div></>)}

                </Container>
            </Modal.Body>
        </Modal>
    )
}


export default MailExpiry